import { render } from "./deletar_disciplina_professor.vue?vue&type=template&id=14461506"
import script from "./deletar_disciplina_professor.vue?vue&type=script&lang=js"
export * from "./deletar_disciplina_professor.vue?vue&type=script&lang=js"

import "./deletar_disciplina_professor.vue?vue&type=style&index=0&id=14461506&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__